<template>
    <section class="company-sites">
        <div class="container" v-if="sites.length">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mt-4 mb-4">
                        <h2>{{ $t("Please select one of the sites below to begin purchasing") }}</h2>
                    </div>
                </div>
            </div>

            <div class="row">
                <div :key="site.id" class="col-md-4 col-6 mb-4 d-flex" v-for="site in sites">
                    <a :href="`/${site.slug}`" class="card mb-4 flex-fill no-gutters company-logo-site h-100 d-flex">
                        <div class="img-company-sites image-wrapper image-loading">
                            <img :data-src="`/images/site-option/${site.logo || 0}?width=288&height=200&fit=fill`"
                                alt="Site logo" class="lazyload img-fluid" style="flex: 0">
                        </div>

                        <div class="card-footer text-center d-flex justify-content-center align-items-center p-1"
                            style="flex: 1">
                            <h5><a>{{ site.name }}</a></h5>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <vue-alert class="mt-4" type="warning" v-else>
            {{ $t("We could not connect to the server. Please try again later.") }}
        </vue-alert>
    </section>
</template>

<script>
export default {
    data() {
        return {
            sites: []
        }
    },
    methods: {
        fetch() {
            this.$axios
                .get('/sites')
                .then(response => this.sites = response.data.items);
        }
    },
    mounted() {
        this.fetch();

        this.$pageTitle = this.$t("Sites");
    }
}
</script>
